/** css **/
import './assets/css/kendo-webparteneri.css';
import './assets/css/reset.css'
import './assets/css/app.css';

/** js **/
import React from 'react';
import ReactDOM from 'react-dom/client';
import { LangProvider } from "./langProvider";
import App from './App';
import './components/shared/app.defaults';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<LangProvider><App /></LangProvider>);